import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AboutSection from "../page-components/about-us/AboutSection";
import OurTeam from "../page-components/about-us/OurTeam";
import TabHistory from "../page-components/about-us/TabHistory";
import NavBelt from "../page-essentials/NavBelt";
import SocialMedia from "../page-essentials/SocialMedia";
import { AboutBreadCrumpData } from "../static-data/breadcrump";

const About = () => {
  const [activeTab, setActiveTab] = useState("about");
  console.log(activeTab);
  const handleTab = (tab: string) => {
    setActiveTab(tab);
  };
  let TabLayout;
  if (activeTab === "about") TabLayout = <AboutSection />;
  if (activeTab === "history") TabLayout = <TabHistory />;
  if (activeTab === "team") TabLayout = <OurTeam />;

  return (
    <div>
      <NavBelt
        page="About Us"
        img="https://images.unsplash.com/photo-1502920514313-52581002a659?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1167&q=80"
        breadCrumpInfo={AboutBreadCrumpData}
      />
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-8">
          <div className="hidden md:block col-span-3">
            <div className="sticky top-20 mb-5">
              <div className="bg-gray-100 p-8 h-fit w-full space-y-4">
                <h1
                  className={`text-lg font-semibold uppercase ${
                    activeTab === "about" ? "text-primary-base" : "text-black"
                  } hover:text-primary-base cursor-pointer`}
                  onClick={() => handleTab("about")}
                >
                  About us
                </h1>
                <hr />
                <p
                  className={`font-medium cursor-pointer transition ${
                    activeTab === "history" ? "text-primary-base" : "text-black"
                  } hover:text-primary-base`}
                  onClick={() => handleTab("history")}
                >
                  History
                </p>
                <p
                  className={`font-medium cursor-pointer transition ${
                    activeTab === "" ? "text-primary-base" : "text-black"
                  } hover:text-primary-base`}
                  onClick={() => handleTab("")}
                >
                  Vision Mission
                </p>
                <p
                  className={`font-medium cursor-pointer transition ${
                    activeTab === "" ? "text-primary-base" : "text-black"
                  } hover:text-primary-base`}
                >
                  Legal Documents
                </p>
                <p
                  className={`font-medium cursor-pointer transition ${
                    activeTab === "team" ? "text-primary-base" : "text-black"
                  } hover:text-primary-base`}
                  onClick={() => handleTab("team")}
                >
                  Our Team
                </p>
                <p
                  className={`font-medium cursor-pointer transition ${
                    activeTab === "" ? "text-primary-base" : "text-black"
                  } hover:text-primary-base`}
                >
                  Management
                </p>
              </div>
              <div className="w-40 my-8">
                <SocialMedia color="text-primary-base" />
              </div>
              <p className="my-3 text-lg font-semibold">
                Subscribe our newslatter
              </p>
              <form className="flex items-center my-4">
                <input
                  type="text"
                  className="py-2 px-2 w-full text-black text-sm rounded-none border-gray-500"
                  placeholder="johndoe@gmail.com"
                />
                <input
                  type="submit"
                  value="Subscribe"
                  className="bg-optional px-4 py-2 text-sm transition duration-700 hover:opacity-90 border border-optional"
                />
              </form>
            </div>
          </div>
          {/* main content section right grid  */}
          <div className="col-span-8">
            <br />
            {TabLayout}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
